import React from 'react';
import PageBanner from 'components/banners/PageBanner';
import { Col, Container, Image, Row } from 'react-bootstrap';
import styles from './case-study.module.scss';
import caseStudyBanner from 'assets/images/case-study.jpg';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';

function CaseStudy() {
  return (
    <div>
      <Helmet>
        <title>Case Study - CAP60</title>
        <meta
          name="description"
          content="Look at glance on case study for more information. Contact us Now!."
        />
        <meta name="keyword" content="case study" />
      </Helmet>
      <PageBanner
        title="Just in Case, Studies to Help You"
        subtitle="Learn more about how we delivered better data experiences"
      />
      <div className={styles.caseStudyWrap}>
        <Container>
          <Image src={caseStudyBanner} fluid />
          <Row className="my-3 mt-4">
            <Col md={8} className="mb-2">
              <p className="font-s1 mb-2">
                Web County Community Action Agency, Laredo, Texas
              </p>
              <h4 className="font-s1 fw800">
                Webb County, TX: A Case Study on Accelerated Implementation
              </h4>
            </Col>
            <Col md={4} className="text-md-right">
              <Link to={`/contact-us`}>
                <RequestDemoButton />
              </Link>
            </Col>
          </Row>
          <hr />
          <p>
            Webb County Community Action Agency’s mission is to help their Texas
            Community achieve an improved quality of life through access to new
            opportunities, attainment of useful skills and knowledge, and
            achievement of economic self-sufficiency.
          </p>
          <p>
            Upon their switch to CAP60, Webb County was given a solution that
            would help them to reach all three goals. CAP60 presented Webb
            County with the opportunity to replace their outdated data
            management process, gain new computer and data management related
            skills, and achieve economic self-sufficiency through easy
            monitoring and reporting of funds used and funds available.
          </p>
          <p>
            Webb County’s process prior to CAP60 left a paper trail of
            confusion. Each case worker, spread between five centers, was to
            send their manually filled-out Excel Spreadsheets to the Community
            Social Services Manager. This process resulted in Webb County CAA
            facing tremendous verification and duplication problems. Often,
            appointments were either double-booked or cancelled without
            documentation. This frustrated clients and created long lines at
            their centers.
          </p>
          <p>
            When Mayra Granados, the new Community Social Services Manager, came
            on board, she uncovered an egregious accounting error, finding a
            large discrepancy in their finances. Their agency had unknowingly
            over-spent by $80,000 for that fiscal year due to miscommunication
            of their program, funding and client data. The end result was
            cancellation of some client services for the last three months of
            the year.
          </p>
          <p>
            They needed a fast and effective solution: CAP60. Working as a team,
            Webb County CAA and CAP60 developed a detailed project plan and were
            able to complete the implementation process in less than three
            weeks.
          </p>
          <p>
            Granados explained that implementation is a very well-thought out
            process, emphasizing that the most important factor is “to consider
            the staff you currently have.” With that in mind, she created a
            training process which included a training schedule, a process for
            questions, and a user guide customized to meet her staff’s needs.
            These were coordinated with the CAP60 training schedule.
          </p>
          <p>
            Granados trained with the CAP60 implementation team in the morning,
            and then would relay the information to the staff members the
            following afternoon. By centralizing all of the staff’s members at
            the main center and pairing them off in partners, they were able to
            practice back and forth until memorized. Within a few weeks, her
            team was proficient with the system and no longer needed to use the
            training material.
          </p>
          <p>
            Further, Granados emphasized that when creating an implementation
            timeline, it’s important for an agency “to consider its different
            programs.” Webb County Community Action Agency has three programs,
            so that the case workers, on average, learned one program per week.
            Granados suggested that agencies be “realistic” with their timeline
            when considering the number of programs being implemented.
          </p>
          <p>
            Upon switching to CAP60, the agency’s lines shortened, appointments
            were schedules without overlap, and funds were properly accounted
            for which increased the accuracy of the reporting. By addressing
            these problem areas which once impaired agency operations, Mayra
            Granados says that CAP60 alleviated the headaches” that once
            burdened her staff.
          </p>
          <i>Webb County Community Action Agency, Laredo, Texas</i>
          <div className="mt-2">
            <RequestDemoButton />
          </div>
        </Container>
      </div>
    </div>
  );
}

export default CaseStudy;
